import { ROUTE_IDS } from '../../experience/routes/ids.js';
import { COMMON_AVATAR_ROUTE_IDS, PLATFORM_ROOT_ADMIN_BASELINE_MODULES, PLATFORM_ROOT_ADMIN_DENIED_ROUTE_IDS, PLATFORM_ROOT_ADMIN_FORBIDDEN_MODULES, } from './presets.js';
export const PLATFORM_ROOT_ACCESS_PROFILE = {
    persona: 'PLATFORM_ROOT',
    actorTypes: ['USER', 'SERVICE_ACCOUNT'],
    scope: {
        allowedKinds: ['SYSTEM', 'PLATFORM'],
        defaultKind: 'SYSTEM',
        organizationRequired: false,
        branchRequired: false,
        clientRequired: false,
        ownershipPolicy: 'PLATFORM',
    },
    authentication: {
        defaultAal: 'AAL2',
        administrationAal: 'AAL2',
    },
    navigation: {
        landingRouteId: ROUTE_IDS.DASHBOARD,
        primaryRouteIds: [
            ROUTE_IDS.DASHBOARD,
            ROUTE_IDS.DATA_HUB,
            ROUTE_IDS.REPORTS,
            ROUTE_IDS.ADMIN_HUB,
        ],
        avatarRouteIds: COMMON_AVATAR_ROUTE_IDS,
        structurallyDeniedRouteIds: PLATFORM_ROOT_ADMIN_DENIED_ROUTE_IDS,
    },
    access: {
        defaultOperationBundleIds: ['platform-root'],
        allowedOperationBundleIds: ['platform-root'],
    },
    modules: {
        baseline: PLATFORM_ROOT_ADMIN_BASELINE_MODULES,
        optional: [],
        forbidden: PLATFORM_ROOT_ADMIN_FORBIDDEN_MODULES,
    },
    administration: {
        resourceIds: [
            'platform-organizations',
            'platform-modules',
            'platform-users',
            'platform-audit',
            'platform-health',
            'platform-support-delegations',
            'platform-access-inspector',
        ],
    },
    context: {
        maySwitchOrganization: false,
        maySwitchBranch: false,
        maySelectClient: false,
        maySelectPortfolio: false,
    },
    delegation: {
        mayInitiate: true,
        mayReceive: false,
        organizationDataRequiresDelegation: true,
    },
    mutationPolicy: 'FULL_WITHIN_SCOPE',
};
